import { gql } from '@apollo/client';

export const GET_INVOICE_DETAILS_BY_REF = gql`
  query GetInvoiceDetailsByRef(
    $ref: String!,
    $type: String,
    $journal_id: Int
  ) {
    getInvoiceDetailsByRef(
      ref: $ref,
      type: $type,
      journal_id: $journal_id
    ) {
      status
      details {
        ref
        date
        invoice_lines {
          label
          amount
        }
        total
      }
    }
  }
`;
